import "./style.scss";
import CloseSvg from "@/src/svg/CloseSvg";
import { Link, useNavigate } from "react-router-dom";
import NavigationArrowSvg from "@/src/svg/NavigationArrowSvg";
import { FC, Fragment, useEffect, useState } from "react";
import { INavigationsData } from "@/src/types/INavigation";
import { navigationConst, navigationDynamicConst } from "@/src/constants/navigation";
import NavigationItem from "./NavigationItem/NavigationItem";

interface INavigation {
  currentNavigationName?: string;
}

const Navigation: FC<INavigation> = ({ currentNavigationName }) => {
  const navigate = useNavigate();
  const [currentData, setCurrentData] = useState<INavigationsData>(navigationConst);

  useEffect(() => {
    if (currentNavigationName !== "NavigationPage") {
      navigationDynamicConst.forEach((item) => {
        if (item.id === currentNavigationName) {
          setCurrentData(item);
        }
      });
    }
  }, [currentNavigationName]);
  return (
    <div className="navigation">
      <div className="navigation-header">
        <div className="navigation-back" onClick={() => navigate(-1)}>
          <NavigationArrowSvg />
        </div>
        <Link to={"/"} className="navigation-close">
          <CloseSvg />
        </Link>
      </div>
      <div className="navigation-body">
        <div className="title">
          <p>{currentData.title}</p>
        </div>
        <div className="navigation-items">
          {currentData.data.map((item) => (
            <Fragment key={item.id}>
              <NavigationItem id={item.id} text={item.text} image={item.image} link={item.link as undefined} />
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Navigation;
